(function dynamicControlDirectiveDefinition() {
    'use strict';

    angular.module('CustomControls', ['CustomControlText', 'CustomControlDate', 'CustomControlNumber', 'CustomControlCombo', 'CustomControlUser', 'CustomControlMaskedText', 'CustomControlComboKeyValue', 'CustomControlTextArea', 'CustomControlComboKeyValueMultiple', 'CustomControlComboMultiple', 'CustomControlPeriod', 'angucomplete-alt',
                                      'angucompleteExtend', 'SystemTranslateFilter'])
        .directive('dynamicControl', [
            '$compile',
            function ($compile) {
                return {
                    restrict: 'E',
                    require: ['^form'],
                    scope: {
                        data: '=',
                        parentfun: '&',
                        controlchange: '&',
                        hideadditem: '=',
                        hideinactive: '=',
                        ouId: '@'
                    },
                    link: function (scope, element, attrs, ctrls) {

                        var template,
                            formCtrl = ctrls[0];
                        switch (attrs.type) {
                            case 'date':
                            case 'Date':
                                template = 'dynamic-date';
                                break;
                            case 'number':
                            case 'Number':
                                template = 'dynamic-number';
                                break;
                            case 'combo':
                            case 'Combo':
                                template = 'dynamic-combo';
                                break;
                            case 'userControl':
                                template = 'dynamic-user';
                                break;
                            case 'maskedText':
                            case 'MaskedText':
                                template = 'dynamic-masked-text';
                                break;
                            case 'period':
                                template = 'dynamic-period';
                                break;
                            case 'comboKV':
                            case 'ComboKV':
                                template = 'dynamic-combo-key-value';
                                break;
                            case 'textArea':
                                template = 'dynamic-text-area';
                                break;
                            default:
                                template = 'dynamic-text';
                        }

                        if (scope.data.metadataIsMultivalue) {
                            template =  template + '-multiple';
                        }

                        scope[formCtrl.$name] = scope.$parent[formCtrl.$name];
                        var innerElement = document.createElement(template);

                        scope.tabIndex = parseInt(attrs.tabindex || '0', 10);
                        element.append(innerElement);
                        $compile(innerElement)(scope);

                        scope.control = function (value) {
                            return scope.controlchange({ $value: value });
                        }
                    }
                };
            }
        ]);

    angular.module('CustomControls')
        .directive('dynamicFilterControl', [
            '$compile',
            function ($compile) {
                return {
                    restrict: 'E',
                    scope: {
                        data: '=',
                        parentfun: '&'
                    },

                    link: function (scope, element, attrs) {

                        var template;
                        switch (attrs.type) {
                            case 'date':
                            case 'Date':
                                template = 'dynamic-filter-date';
                                break;
                            case 'number':
                            case 'Number':
                                template = 'dynamic-filter-number';
                                break;
                            case 'combo':
                            case 'Combo':
                                template = 'dynamic-filter-combo';
                                break;
                            case 'userControl':
                                template = 'dynamic-filter-user';
                                break;
                            case 'maskedText':
                            case 'MaskedText':
                                template = 'dynamic-filter-masked-text';
                                break;
                            case 'period':
                                template = 'dynamic-filter-period';
                                break;
                            case 'comboKV':
                            case 'ComboKV':
                                template = 'dynamic-filter-combo-key-value';
                                break;
                            default:
                                template = 'dynamic-filter-text';
                        }

                        if (scope.data.metadataIsMultivalue) {
                            template = template + '-multiple';
                        }

                        var innerElement = document.createElement(template);
                        innerElement.setAttribute('filterNullValue', attrs.filternullvalue);

                        scope.tabIndex = parseInt(attrs.tabindex || '0', 10);
                        element.removeAttr('tabindex');
                        element.append(innerElement);
                        $compile(innerElement)(scope);
                    }
                };
            }
        ]);
})();